<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import {mapMutations, mapActions} from "vuex";
  import UserPersistence from "./persistence/UserPersistence";
  import {EXIT_URL} from "./config/app";

export default {
  name: 'App',
  watch: {
    '$route'(to) {
      // this.onRouteChange(to);
    },
  },
  computed: {},
  methods: {
    ...mapActions("app", {
      // onRouteChange: "onRouteChange",
    }),
    ...mapMutations('user', [
      'setUserBaseInfo'
    ])
  },
  created() {
    this.setUserBaseInfo(UserPersistence.getBaseInfo())
  },
}
</script>
<style lang="scss">
  @import "styles/reset";
  @import "styles/base";
  @import "styles/button";
  @import "styles/dialogBase";
  @import "styles/tableBase";
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    /*-webkit-font-smoothing: subpixel-antialiased;*/
    /*-moz-osx-font-smoothing: grayscale;*/
    /*color: #2c3e50;*/
    height: 100%;
    margin: 0;

  }
</style>



// WEBPACK FOOTER //
// src/App.vue